<template>
    <v-row class="ma-0 prinPage" justify="center" style="align-content: center !important; height: 100%;" >
        <v-btn height="100" color='red' class="mx-4" @click="cambiarURL(0)">
            <h1>SmartLink Cananea</h1>
        </v-btn>
        <v-btn  height="100" color='orange' class="mx-4" @click="cambiarURL(1)">
            <h1>SmartLink Collahuasi</h1>
        </v-btn>
    </v-row>
</template>

<script setup lang="ts">
import { changeURL }  from '@/constants/apis';
import { PRINCIPAL_PAGE } from '@/interfaces/SmartLink/Equipos';
import router from '@/router';
import { useStore }   from 'vuex';
const store     = useStore();

const values:PRINCIPAL_PAGE = {
    0 : [
        process.env.VUE_APP_NAME_PROJECT_CANANEA,
        process.env.VUE_APP_MAP_LAT_CANANEA,
        process.env.VUE_APP_MAP_LNG_CANANEA,
        process.env.VUE_APP_MAP_ZOOM_CANANEA,
    ],
    1 : [
        process.env.VUE_APP_NAME_PROJECT_COLLAHUASI,
        process.env.VUE_APP_MAP_LAT_COLLAHUASI,
        process.env.VUE_APP_MAP_LNG_COLLAHUASI,
        process.env.VUE_APP_MAP_ZOOM_COLLAHUASI,
    ],
}


const cambiarURL = (valor:number) => {
    changeURL(valor)
    router.push('/smartlink/dashboard')
    store.commit('setAppBarPage','smartlinkPage');
    store.commit('setProjectName',values[valor][0]);
    store.commit('setProjectLAT',values[valor][1]);
    store.commit('setProjectLNG',values[valor][2]);
    store.commit('setProjectZOOM',values[valor][3]);
}

</script>

<style>


.prinPage{
    background-color: #000000;
    background-image: url('@/assets/svg/bg.svg');
    background-attachment: fixed;
    background-size: cover;
}
</style>
